export const AI_NOTE_TYPE = 'AI_NOTE'

export const toAgentNotes = (notes) => (
  (Array.isArray(notes) ? notes : []).map((note) => ({
    ...note,
    createdAt: note.createdAt ? note.createdAt * 1000 : null
  }))
)

export const mergeAgentNotes = (oldNotes, newNotes) => {
  const notes = Array.isArray(oldNotes) ? [...oldNotes] : []

  for (const note of Array.isArray(newNotes) ? newNotes : []) {
    const index = notes.findIndex(({ id }) => id === note.id)
    if (index !== -1) notes.splice(index, 1, note)
    else notes.push(note)
  }

  return notes
}

const toTimelineNote = (note) => ({
  id: `note-${note.id}`,
  type: AI_NOTE_TYPE,
  chatId: note.chatId,
  reason: note.reason || '',
  summary: note.summary || '',
  createdAt: note.createdAt
})

export const interleaveAgentNotes = (messages, notes) => {
  if (!Array.isArray(notes) || !notes.length) return messages

  const afterMessage = {}
  const beforeChat = {}
  for (const note of notes) {
    const [index, key] = note.afterMessageId == null ? [beforeChat, String(note.chatId)] : [afterMessage, String(note.afterMessageId)]
    index[key] = [...(index[key] || []), note]
  }

  const placedChats = new Set()
  return messages.reduce((timeline, message) => {
    const chatKey = String(message.chatId)
    if (!placedChats.has(chatKey)) {
      placedChats.add(chatKey)
      timeline.push(...(beforeChat[chatKey] || []).map(toTimelineNote))
    }
    timeline.push(message, ...(afterMessage[String(message.id)] || []).map(toTimelineNote))
    return timeline
  }, [])
}
